import { render, staticRenderFns } from "./PulseSettings.vue?vue&type=template&id=744a6434&scoped=true"
import script from "./PulseSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./PulseSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PulseSettings.vue?vue&type=style&index=0&id=744a6434&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744a6434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744a6434')) {
      api.createRecord('744a6434', component.options)
    } else {
      api.reload('744a6434', component.options)
    }
    module.hot.accept("./PulseSettings.vue?vue&type=template&id=744a6434&scoped=true", function () {
      api.rerender('744a6434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pulse/PulseSettings.vue"
export default component.exports